import React from 'react';
import styled from 'styled-components';
import Wordmark from '../lib/images/vista-wordmark-colour.svg';

const StyledWordmark = styled.div`
    display: inline-block;
    text-align: center;
    width: 120px;
    height: 40px;
`;

export function VistaWordmark() {
    return (
        <StyledWordmark
            aria-label="Vista"
            dangerouslySetInnerHTML={{
                __html: Wordmark,
            }}
        />
    );
}
